import React from "react";
import IBaseFormComponentProps from "../../../interfaces/IBaseFormComponentProps";
import cx from "classnames";
import ValidationMessage from "../ValidationMessage/ValidationMessage";
import ToolTip from "../../Tooltips/Tooltip";

interface IInputWrapperProps
    extends Pick<
        IBaseFormComponentProps<Element, unknown>,
        "label" | "tooltipContent" | "hasError" | "className" | "isDisabled"
    > {
    isFullWidth?: boolean;
    id?: string;
}

const InputWrapper: React.FC<IInputWrapperProps> = (props) => {
    const { label, tooltipContent, hasError, className, isDisabled, children, id } = props;

    // Default True
    const isFullWidth = props.isFullWidth === undefined || props.isFullWidth;

    return (
        <div
            id={id}
            className={cx("layout-flex-column--baseline", "flex-gap-s", {
                [className]: !!className,
                ["fade-light"]: isDisabled
            })}>
            {label && (
                <span
                    aria-label={label.toString()}
                    className={cx("text-font-size-s", "text-bold", "gap-none", {
                        ["text-error"]: hasError
                    })}>
                    {label}
                </span>
            )}
            <div className="layout-flex-row--centered width-full">
                <div className={cx({ "layout-flex-s": isFullWidth })}>{children}</div>
                {tooltipContent && (
                    <ToolTip
                        tooltipContent={tooltipContent}
                        className="space-pre-m"></ToolTip>
                )}
            </div>
            {hasError && typeof hasError === "string" && (
                <ValidationMessage>{hasError}</ValidationMessage>
            )}
        </div>
    );
};

export default InputWrapper;
